import { render, staticRenderFns } from "./TableWlAddons.vue?vue&type=template&id=1ce5c24e&scoped=true"
import script from "./TableWlAddons.vue?vue&type=script&lang=js"
export * from "./TableWlAddons.vue?vue&type=script&lang=js"
import style0 from "./TableWlAddons.vue?vue&type=style&index=0&id=1ce5c24e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce5c24e",
  null
  
)

export default component.exports